import { useParams } from "react-router-dom"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, EmailInput, PhoneInput, Select, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"
import { useOptions } from "../../hooks/useOptions"

export const useTitleOptions = () => {
    const t = useTranslations()
    return [
        { value: 'Monsieur', label: t('Monsieur') },
        { value: 'Madame', label: t('Madame') },
        { value: 'Mevrouw', label: t('Mevrouw') },
        { value: 'Mijnheer', label: t('Mijnheer') },
        { value: 'Docteur', label: t('Docteur') },
        { value: 'Maitre', label: t('Maitre') },
    ]
}

function ContactFields({ item, set, tab }) {
    const t = useTranslations()
    const titleOptions = useTitleOptions()
    const gerantOptions = useOptions('gerants', 'nom')
    const clientOptions = useOptions('clients', 'nom')
    const { relatedId } = useParams()

    const onGerantChange = id => {
        set('gerantId')(id)
        if (item.clientId) set('clientId')(null)
    }
    const onClientChange = id => {
        set('clientId')(id)
        if (item.gerantId) set('gerantId')(null)
    }

    return <>
        {!relatedId && <Row>
            <AsyncSelect label={t("Gérant")} value={item.gerantId} onChange={onGerantChange} options={gerantOptions} required={!item.clientId} />
            <AsyncSelect label={t("Client")} value={item.clientId} onChange={onClientChange} options={clientOptions} required={!item.gerantId} />
        </Row>}
        <Row>
            <Select label={t("Titre")} value={item.titre} onChange={set('titre')} options={titleOptions} />
            <TextInput className="grow" label={t("Nom")} value={item.nom} onChange={set('nom')} required />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Fonction")} value={item.fonction} onChange={set('fonction')} />
            <PhoneInput className="grow" label={t("Téléphone")} value={item.tel} onChange={set('tel')} />
            <PhoneInput className="grow" label={t("GSM")} value={item.mobilophone} onChange={set('mobilophone')} />
        </Row>
        <EmailInput label={t("Email")} value={item.email} onChange={set('email')} />
        <Row>
            <Checkbox label={t("CC factures")} value={item.ccFacturation} onChange={set('ccFacturation')} />
            <Checkbox label={t("CC rappels")} value={item.ccRappels} onChange={set('ccRappels')} />
            <Checkbox label={t("CC offres")} value={item.ccOffre} onChange={set('ccOffre')} />
        </Row>
    </>
}

export function ContactsList(props) {
    const t = useTranslations()
    return <ListPage model="contacts" title={t("Contacts")} columns={{
        [t('Nom')]: 'nom',
        [t('Fonction')]: 'fonction',
        [t('Téléphone')]: 'tel',
        [t('GSM')]: 'mobilophone',
        [t('Email')]: 'email',
        [t('CC factures')]: 'ccFacturation',
        [t('CC rappels')]: 'ccRappels',
        [t('CC offres')]: 'ccOffre',
    }} {...props} />
}

export function ContactDetail(props) {
    const t = useTranslations()
    return <DetailPage model="contacts" title={t("Contact")} Fields={ContactFields} {...props} />
}
